import React from 'react';
import SvgIcon from 'utils/SvgIcon';

const SyncIcon = ({ fillColor, hoverFill, style }) => (
  <SvgIcon
    {...{ fillColor, hoverFill, style }}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5 12.75V14.25C15.5711 14.25 17.25 12.5711 17.25 10.5C17.25 8.61372 15.8573 7.05272 14.0441 6.78918C13.4063 4.57922 11.369 3 9 3C7.24008 3 5.63176 3.8738 4.66492 5.28771C2.45027 5.5751 0.75 7.46908 0.75 9.75C0.75 11.9797 2.37172 13.8307 4.5 14.1878V12.6555C3.20608 12.3225 2.25 11.1479 2.25 9.75C2.25 8.13783 3.52451 6.81536 5.12974 6.75236L5.543 6.73613L5.74981 6.37799C6.41572 5.22482 7.6443 4.5 9 4.5C10.8383 4.5 12.3978 5.8322 12.6982 7.62462L12.8053 8.26363L13.4531 8.25048C13.4648 8.25028 13.4706 8.25018 13.4765 8.25012C13.4824 8.25006 13.4882 8.25004 13.5 8.25C14.7426 8.25 15.75 9.25736 15.75 10.5C15.75 11.7426 14.7426 12.75 13.5 12.75ZM8.25 9V13.6899L6.53033 12.007L5.46967 13.045L9 16.5L12.5303 13.045L11.4697 12.007L9.75 13.6899V9H8.25Z"
    />
  </SvgIcon>
);

export default SyncIcon;
